import { observable, computed, action } from "mobx";
import {PATH_MENU_PRINCIPALI} from '../config/portale-config'

class MenuStore {

  constructor(root) {   
    this.service = root.service
  }

  @observable
  menuItems = []

  @action
  fetchMenuItems() {      
    this.service.doAjax('GET', PATH_MENU_PRINCIPALI).then(response => {if(response.success) this.menuItems = response.result.items})
  }
}

export default MenuStore;